module.exports = __webpack_public_path__ + "img/母乳.b94b0166.jpg";